module.exports = __webpack_public_path__ + "static/img/background.61a6d979.svg";